// extracted by mini-css-extract-plugin
export default {"heading":"GR1yNy","xs":"xoG6uI","content":"IFWloZ","card":"YSyQ88","image":"SIHh1B","fresh-plan":"HHCnFo","freshPlan":"HHCnFo"};